import {
    SERVER_FULL_NAME,
    SERVER_SLOGAN,
    STROLLER_HOME_COPY,
    STROLLER_NO_RESULTS,
    STROLLER_STROLLEROPEDIA,
    STROLLEROPEDIA_BRANDS_LIST,
    STROLLEROPEDIA_MORE_ARTICLES,
    STROLLEROPEDIA_NEW_ARTICLES,
    STROLLERS_ASK_OUR_STROLLER_EXPERT,
    STROLLERS_GOT_A_QUESTION,
    STROLLERS_SEARCH_HOMEPAGE_BTN_TITLE,
} from 'mk/autogenerated/translations/BrandsList.1d576193b71289c44233886860a1ef87'
import assetUrl from 'mk/common/assetUrl';
import { photoUrl } from 'mk/photo/photoUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { articleUrl as blogsArticleUrl } from 'mk2/apps/blogs/utils';
import { counsellingsTopicUrl } from 'mk2/apps/counsellings/urls';
import { BrandsListItem, BrandsListItemPlaceholder } from 'mk2/apps/strollers/components/BrandsListItem';
import { Props } from 'mk2/apps/strollers/containers/BrandsList/BrandsListPage';
import { PageMode } from 'mk2/apps/strollers/containers/StrollersSearch/StrollersSearch.constants';
import { strollersSearchUrl } from 'mk2/apps/strollers/urls';
import AvatarImg from 'mk2/components/AvatarImg';
import { BtnType, default as Btn } from 'mk2/components/Btn';
import Img from 'mk2/components/Img';
import ImgResponsive from 'mk2/components/ImgResponsive';
import InfiniteList from 'mk2/components/InfiniteListLoadable';
import Link from 'mk2/components/Link';
import NoResults from 'mk2/components/NoResults';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { url } from 'mk2/helpers/urls';
import { LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './BrandsList.mscss';

const ROW_HEIGHT = 54;

export default class BrandsList extends React.Component<Props> {

    public componentDidMount() {
        this.props.onWishlistIdsLoad();
    }

    public render() {
        const { items, loadingState, guideArticles, strollersCounselling } = this.props;

        return (
            <div className={styles.BrandsList}>
                <ImgResponsive
                    imgUrl={assetUrl + `img/site_specific/sbase-cover.jpg`}
                    width={960}
                    height={639}
                />

                <div className={styles.BrandsList__copy}>
                    <div className={styles.BrandsList__copy__heading}>
                        {ACTIVE_SERVER_ID === 207 ? (
                            <Img
                                width={190}
                                height={30}
                                alt={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                                src={assetUrl + 'img/logos/strollerbase.png'}
                                lazy={false}
                            />
                        ) : (
                            <>
                                {STROLLER_STROLLEROPEDIA}
                            </>
                        )}
                    </div>
                    <div>
                        <div className={styles.BrandsList__copytext}>
                            {STROLLER_HOME_COPY}
                        </div>
                        <Btn
                            type={BtnType.Blue}
                            icon="fa-search"
                            link={url(strollersSearchUrl, {pageMode: PageMode.SHOW_SEARCH_FORM})}
                            label={STROLLERS_SEARCH_HOMEPAGE_BTN_TITLE}
                        />
                    </div>

                    {strollersCounselling && (
                        <div className={styles.BrandsList__askExpert}>
                            <AvatarImg
                                user={strollersCounselling.counsellor}
                                size={36}
                                counsellorAvatar={strollersCounselling.counsellorAvatar}
                            />

                            <div className={styles.BrandsList__askExpertRight}>
                                <div>{STROLLERS_GOT_A_QUESTION}</div>
                                <Link
                                    className={styles.BrandsList__askExpertLink}
                                    to={url(counsellingsTopicUrl, {topicSlug: strollersCounselling.topic.slug})}
                                >
                                    {STROLLERS_ASK_OUR_STROLLER_EXPERT}
                                </Link>
                            </div>
                        </div>
                    )}
                </div>

                {!!guideArticles && guideArticles.length > 0 && (
                    <React.Fragment>
                        <h2 className={styles.Article__header}>{STROLLEROPEDIA_NEW_ARTICLES}</h2>

                        {guideArticles.map((article) => (
                            <Link
                                to={blogsArticleUrl(article)}
                                key={article.id}
                                className={styles.Article}
                            >
                                <div className={styles.Article__wrapper}>
                                    <div className={styles.Article__image}>
                                        <Img className={styles.Article__image__img} src={article.photos.length > 0 ? photoUrl(article.photos[0], 's560x560') : assetUrl + 'img/general/n.gif'} width={80} height={80} />
                                    </div>
                                    <div className={styles.Article__title}>
                                        {article.title}
                                    </div>
                                </div>
                            </Link>
                        ))}

                        {ACTIVE_SERVER_ID !== 207 && (
                            <Btn
                                label={STROLLEROPEDIA_MORE_ARTICLES}
                                type={BtnType.BlueOutline}
                                className={styles.Article__btn}
                                link={url(blogsProfileUrl, {username: guideArticles[0].user.username})}
                            />
                        )}
                    </React.Fragment>
                )}

                <h2 className={styles.BrandsList__header}>{STROLLEROPEDIA_BRANDS_LIST}</h2>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInit}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={items && items.length > 0}
                />
            </div>
        );
    }

    private renderInit = () => {
        return (
            <span>
                <BrandsListItemPlaceholder style={{height: ROW_HEIGHT}} />
                <BrandsListItemPlaceholder style={{height: ROW_HEIGHT}} />
                <BrandsListItemPlaceholder style={{height: ROW_HEIGHT}} />
                <BrandsListItemPlaceholder style={{height: ROW_HEIGHT}} />
                <BrandsListItemPlaceholder style={{height: ROW_HEIGHT}} />
                <BrandsListItemPlaceholder style={{height: ROW_HEIGHT}} />
            </span>
        );
    };

    private renderLoadSuccess = () => {
        const { items, hasMore } = this.props;
        const rowCount = hasMore ? items.length + 1 : items.length;

        return (items.length > 0) ? (
            <InfiniteList
                isRowLoaded={this.isRowLoaded}
                loadMoreRows={this.loadNext}
                rowCount={rowCount}
                rowHeight={ROW_HEIGHT}
                rowRenderer={(props) => this.rowRenderer(props) /* tslint:disable-line */}
                numberOfItemsOnFirstPage={100}
            />
        ) : (
            <NoResults message={STROLLER_NO_RESULTS} noIcon />
        );
    };

    private load = () => {
        this.props.onLoad();
    };

    private loadNext = () => {
        // Do not trigger next load
        if (this.props.loadingState === LoadingState.LOADING) {
            return;
        }

        const { items, onLoad } = this.props;

        let after = null;
        if (items.length) {
            after = items[items.length - 1].slug;
        }
        onLoad(after);

        // Debounce loadMoreRows
        return new Promise((resolve) => {
            setTimeout(resolve, 500);
        });
    };

    private isRowLoaded = ({ index }) => !this.props.hasMore || index < this.props.items.length;

    private rowRenderer = ({ index, key, style }) => {
        const { items } = this.props;

        if (!this.isRowLoaded({ index })) {
            return (
                <BrandsListItemPlaceholder key={key} style={{ ...style, height: ROW_HEIGHT }} />
            );
        }

        const item = items[index];

        return (
            <BrandsListItem brand={item} key={key} style={style} />
        );
    };

}
